import React from "react";
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import ContactSection from "../components/ContactSection";
import FooterSection from "../components/FooterSection";
// import FaqSection from '../components/FaqSection';
import NumberCount from "../components/NumberCount";
import MsportModal from "../components/MsportModal";


export default function Contact() {
  const [showModal, setShowModal] = React.useState(true);
  return (
    <div>
       {showModal && <MsportModal setShowModal={setShowModal} />}
      <Header />
      <PagesHero page={"contact"} />
      <ContactSection />
      {/* <FaqSection /> */}
      <NumberCount />
      <FooterSection />
    </div>
  );
}
